import { store } from '../store/store';
import { patchAuthUserUiTheme } from '../store/authSlice';
import themeRuntime from './themeRuntime';

let userSyncHandler = null;

function syncUserTheme(theme) {
	store.dispatch(patchAuthUserUiTheme(theme));
	if (userSyncHandler) {
		userSyncHandler(theme);
	}
}

function setTheme(theme, options = {}) {
	const { updateUser = false, persist = false } = options;
	const effectiveTheme = themeRuntime.applyRuntimeTheme(theme);

	if (updateUser) {
		syncUserTheme(effectiveTheme);
	}

	if (!persist) {
		return Promise.resolve(effectiveTheme);
	}

	return import('./UserManager').then(({ default: UserManager }) =>
		UserManager.updateCurrentUser({ uiTheme: effectiveTheme })
	).then(() => effectiveTheme);
}

function syncFromUser(user) {
	return setTheme(user?.uiTheme || 'light');
}

function setUserSyncHandler(handler) {
	userSyncHandler = handler;
}

/** @deprecated Use setTheme */
function applyTheme(theme) {
	return setTheme(theme);
}

const ThemeManager = {
	isActivatePlatform: themeRuntime.isActivatePlatform,
	setTheme,
	getCurrentTheme: themeRuntime.getCurrentTheme,
	applyTheme,
	syncFromUser,
	setUserSyncHandler,
	subscribeThemeChange: themeRuntime.subscribeThemeChange,
	getCachedTheme: themeRuntime.getCachedTheme,
	setCachedTheme: themeRuntime.setCachedTheme,
	clearCache: themeRuntime.clearCache
};

export default ThemeManager;
